import { Card } from "antd";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import PLACEHOLDER_IMG from "../../../assets/images/avatar.svg";
import TitleBar from "../../../components/common/TitleBar";
import CustomEmpty from "../../../components/ui/CustomEmpty";
import CustomPagination from "../../../components/ui/CustomPagination";
import Loader from "../../../components/ui/Loader";
import {
  useGetAllNotificationQuery,
  useNotificationStatusMutation,
} from "../../../features/organization/notificatons/notificationApi";
import useError from "../../../hooks/useError";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { skipData } from "../../../utils/utils";

export default function Notification() {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const { page, limit, handlePagination } = useTable();
  const { isError, error, isLoading, data } = useGetAllNotificationQuery({
    params: {
      business_id: user?.business_id,
      skip: skipData(page, limit),
      limit,
    },
  });
  const [
    notificationStatus,
    { isLoading: isUpdateLoading, isError: isUpdateError, error: updateError },
  ] = useNotificationStatusMutation();
  useError(isError, error, "Notification get fail");
  useError(isUpdateError, updateError, "Notification read fail");

  const notifications = data?.data?.notifications;

  return (
    <>
      <SidebarLayout title="Notification">
        <TitleBar title="Notification List">
          {/* <Select
            className="min-w-[100px]"
            placeholder="All"
            size="small"
            allowClear
            showSearch
            suffixIcon={<SelectDropdownLgIcon />}
          /> */}
        </TitleBar>

        <div>
          {isLoading ? (
            <Loader />
          ) : notifications?.length ? (
            <>
              {notifications?.map((el: any) => (
                <Card
                  className={`mb-4 cursor-pointer ${
                    el?.status === "unread"
                      ? "bg-gray/40 border-gray"
                      : "bg-white"
                  }`}
                  key={el?.id}
                  onClick={() => {
                    if (!isUpdateLoading) {
                      if (el?.status === "unread") {
                        notificationStatus({
                          ids: [el?.id],
                        });
                      }

                      if (el?.target_type === "proposal" && el?.target_id) {
                        navigate(
                          `/organization/proposals/details/${el?.target_id}`
                        );
                      } else if (
                        el?.target_type === "project" &&
                        el?.target_id
                      ) {
                        navigate(
                          `/organization/my-projects/details/${el?.target_id}`
                        );
                      }
                    }
                  }}
                >
                  <div className="flex justify-start items-center gap-4">
                    <div>
                      <img
                        src={el?.img || PLACEHOLDER_IMG}
                        alt="user_image"
                        className="w-11 h-11 rounded-[100px]"
                      />
                    </div>
                    <div>
                      <div className="flex justify-start items-center gap-4">
                        {/* <div className="justify-start text-slate-700 text-sm font-medium">
                        Md Jubaer Ahmed
                      </div> */}
                        <div className="justify-start text-slate-700 text-sm font-normal">
                          {el?.log_msg}
                        </div>
                      </div>
                      <div className="justify-start text-slate-400 text-sm font-normal">
                        {moment.utc(el?.created_at).local().format("DD MMM")}{" "}
                        {moment.utc(el?.created_at).local().format("hh:mm a")}
                      </div>
                    </div>
                  </div>
                </Card>
              ))}

              <CustomPagination
                total={data?.data?.total || 0}
                limit={limit}
                page={page}
                // hidePagination={hidePagination}
                handlePagination={handlePagination}
              />
            </>
          ) : (
            <CustomEmpty
              rootClassName="pt-10"
              styles={{ image: { height: 100 } }}
            />
          )}
        </div>
      </SidebarLayout>
    </>
  );
}
